import styled from 'react-emotion'

import { mobile } from '../../../../utils/mixins'
import { Typo30WhiteTwoBNBI } from '../../../../themes/Fonts/Nort'

export const SectionHeadingContainer = styled('div')``

export const SectionHeadingText = styled(Typo30WhiteTwoBNBI)`
  letter-spacing: 0.5px;
  line-height: normal;
  margin-top: 0px;
  margin-bottom: 0px;
  ${mobile} {
    font-size: 22px;
    letter-spacing: 0.5px;
  }
`
export const SectionHeadingLine = styled('div')`
  width: 100px;
  border: 1px solid ${props => props.color};
  margin-top: 10px;
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/common/SectionHeading/styledComponents.js